import { makeStyles } from "@material-ui/core";
import React from "react";
import Content from "./content";
import { useSelector } from "react-redux";
import StepFour from "../../containers/steps/stepFour";
import StepThree from "../../containers/steps/stepThree";
import StepFive from "../../containers/steps/stepFive";
import { StepOne } from "../../containers/steps/stepOne";
import StepTwo from "../../containers/steps/stepTwo";

const useStyles = makeStyles({
  fullWidthHeightFlexColumn: {
    display: "flex",
    flexDirection: "row",
    width: "100vw",
    height: "100vh",
    background: "white"
  }
});

export default function Page(props) {
  const classes = useStyles();
  const pageNumber = useSelector((state) => state.pageNumber);

  const PAGES = {
    1: {
      title: "Wähle einen Ausgangstext aus.",
      content: <StepOne />
    },
    2: {
      title: "Wähle einen Vergleichsstext aus.",
      content: <StepTwo />
    },

    3: {
      title: "Ergebnis der Schlüsselwortextraktion und Verwandtschaft mit festgelegter Taxonomie",
      content: <StepThree />
    },
    4: {
      title: "Bewege den Raum mit der Maus",
      content: <StepFour />
    },
    5: {
      title: "Kontaktiere Uns",
      content: <StepFive />
    }
  };

  return (
    <div className={classes.fullWidthHeightFlexColumn}>
      <Content content={PAGES[pageNumber].content} />
    </div>
  );
}
